import PropTypes from 'prop-types';
import React from 'react';
import { getMediumImage } from '../../../utils/prismic';
import { ProfileContainer } from './styles';

const StaffCard = ({ name, alias, avatar, role }) => {
  const label = name || alias;
  return (
    <ProfileContainer>
      {avatar.url && (
        <img
          src={getMediumImage(avatar).url}
          alt={getMediumImage(avatar).alt || label || ''}
          width="160"
          height="160"
        />
      )}

      <div>
        {label && <h5>{label}</h5>}
        {role && <h6>{role}</h6>}
      </div>
    </ProfileContainer>
  );
};

StaffCard.propTypes = {
  name: PropTypes.string,
  alias: PropTypes.string,
  role: PropTypes.string,
  avatar: PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    url: PropTypes.string,
    dimensions: PropTypes.object,
    thumbnails: PropTypes.object,
  }),
};

export default StaffCard;
